/*import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../config";
import { useTheme } from "../context/ThemeContext";

const NAV_ITEMS = [
  { section: "Général", items: ["Infos d'abonnement", "Préférences", "Notifications"] },
  { section: "Compte", items: ["E-mail", "Mot de passe"] },
];

export default function Parametres() {
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();
  const token = localStorage.getItem("token");
  const [user, setUser] = useState(null);
  const [activePage, setActivePage] = useState("Préférences");
  const [feedback, setFeedback] = useState("");
  const [error, setError] = useState("");

  // États formulaires
  const [langue, setLangue] = useState("fr");
  const [langueNotif, setLangueNotif] = useState("fr");
  const [ancienPassword, setAncienPassword] = useState("");
  const [nouveauPassword, setNouveauPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    if (!token) return navigate("/login");
    fetch(`${API_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((data) => {
        setUser(data);
        setLangue(data.langue || "fr");
        setLangueNotif(data.langueNotification || "fr");
      });
  }, [token, navigate]);

  const notify = (msg, isError = false) => {
    if (isError) setError(msg);
    else setFeedback(msg);
    setTimeout(() => { setFeedback(""); setError(""); }, 3000);
  };

  const saveSettings = async (payload) => {
    const res = await fetch(`${API_URL}/api/auth/update-settings`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
    return res.ok;
  };

  const handleThemeChange = async (newTheme) => {
    setTheme(newTheme);
    await saveSettings({ theme: newTheme });
  };

  const handleLangueChange = async (val) => {
    setLangue(val);
    await saveSettings({ langue: val });
    notify("✅ Langue sauvegardée");
  };

  const handleLangueNotifChange = async (val) => {
    setLangueNotif(val);
    await saveSettings({ langueNotification: val });
    notify("✅ Préférence notification sauvegardée");
  };

  const handlePasswordChange = async () => {
    if (nouveauPassword !== confirmPassword)
      return notify("Les mots de passe ne correspondent pas", true);
    const res = await fetch(`${API_URL}/api/auth/change-password`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ ancienPassword, nouveauPassword }),
    });
    const data = await res.json();
    if (!res.ok) return notify(data.message, true);
    notify("✅ Mot de passe modifié !");
    setAncienPassword(""); setNouveauPassword(""); setConfirmPassword("");
  };

  const handleEmailChange = async () => {
    const res = await fetch(`${API_URL}/api/auth/request-email-change`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    notify(data.message);
  };

  if (!user) return <div className="text-center mt-20" style={{ color: "var(--text-muted)" }}>Chargement...</div>;

  const renderPage = () => {
    switch (activePage) {
      case "Infos d'abonnement":
        return (
          <div>
            <h2 className="text-xl font-semibold mb-6" style={{ color: "var(--text)" }}>Informations d'abonnement</h2>
            <div className="border rounded-xl p-6 space-y-4" style={{ borderColor: "var(--border)" }}>
              <div className="flex justify-between">
                <span style={{ color: "var(--text-muted)" }}>Plan actuel</span>
                <span className="font-semibold text-blue-600">{user.abonnement || "Gratuit"}</span>
              </div>
              <div className="flex justify-between">
                <span style={{ color: "var(--text-muted)" }}>Prochain paiement</span>
                <span style={{ color: "var(--text)" }}>
                  {user.prochainPaiement
                    ? new Date(user.prochainPaiement).toLocaleDateString("fr-FR")
                    : "—"}
                </span>
              </div>
              <div className="flex justify-between">
                <span style={{ color: "var(--text-muted)" }}>Membre depuis</span>
                <span style={{ color: "var(--text)" }}>{new Date(user.createdAt).toLocaleDateString("fr-FR")}</span>
              </div>
            </div>
          </div>
        );

      case "Préférences":
        return (
          <div>
            <h2 className="text-xl font-semibold mb-2" style={{ color: "var(--text)" }}>Préférences</h2>
            <p className="text-sm mb-6" style={{ color: "var(--text-muted)" }}>Définissez vos préférences d'affichage et de langue</p>

            <div className="space-y-6">
            
              <div className="border rounded-xl p-5" style={{ borderColor: "var(--border)" }}>
                <label className="block text-sm font-semibold mb-3" style={{ color: "var(--text-muted)" }}>
                  MODE D'AFFICHAGE
                </label>
                <div className="flex gap-3">
                  {[
                    { value: "light", label: "☀️ Mode jour" },
                    { value: "dark", label: "🌙 Mode nuit" },
                  ].map((opt) => (
                    <button key={opt.value}
                      onClick={() => handleThemeChange(opt.value)}
                      className={`flex-1 py-3 rounded-lg border text-sm font-medium transition ${
                        theme === opt.value
                          ? "bg-blue-600 text-white border-blue-600"
                          : "hover:border-blue-400"
                      }`}
                      style={theme !== opt.value ? { borderColor: "var(--border)", color: "var(--text)" } : {}}>
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>

              
              <div className="border rounded-xl p-5" style={{ borderColor: "var(--border)" }}>
                <label className="block text-sm font-semibold mb-3" style={{ color: "var(--text-muted)" }}>
                  LANGUE D'AFFICHAGE
                </label>
                <select value={langue} onChange={(e) => handleLangueChange(e.target.value)}
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style={{ backgroundColor: "var(--bg)", borderColor: "var(--border)", color: "var(--text)" }}>
                  <option value="fr">🇫🇷 Français</option>
                  <option value="en">🇬🇧 English</option>
                </select>
              </div>
            </div>
          </div>
        );

      case "Notifications":
        return (
          <div>
            <h2 className="text-xl font-semibold mb-2" style={{ color: "var(--text)" }}>Notifications</h2>
            <p className="text-sm mb-6" style={{ color: "var(--text-muted)" }}>Choisissez la langue de vos emails de notification</p>

            <div className="border rounded-xl p-5" style={{ borderColor: "var(--border)" }}>
              <label className="block text-sm font-semibold mb-3" style={{ color: "var(--text-muted)" }}>
                LANGUE DES EMAILS
              </label>
              <select value={langueNotif} onChange={(e) => handleLangueNotifChange(e.target.value)}
                className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ backgroundColor: "var(--bg)", borderColor: "var(--border)", color: "var(--text)" }}>
                <option value="fr">🇫🇷 Français</option>
                <option value="en">🇬🇧 English</option>
              </select>
            </div>
          </div>
        );

      case "E-mail":
        return (
          <div>
            <h2 className="text-xl font-semibold mb-6" style={{ color: "var(--text)" }}>Adresse e-mail</h2>
            <div className="border rounded-xl p-5 space-y-4" style={{ borderColor: "var(--border)" }}>
              <div>
                <p className="text-sm mb-1" style={{ color: "var(--text-muted)" }}>Adresse actuelle</p>
                <p className="font-medium" style={{ color: "var(--text)" }}>{user.email}</p>
              </div>
              <button onClick={handleEmailChange}
                className="w-full py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition">
                Envoyer le lien de modification d'e-mail
              </button>
              <p className="text-xs text-center" style={{ color: "var(--text-muted)" }}>
                Vous rencontrez des difficultés ?{" "}
                <a href="/contact" className="text-blue-500 hover:underline">Contactez le support client.</a>
              </p>
            </div>
          </div>
        );

      case "Mot de passe":
        return (
          <div>
            <h2 className="text-xl font-semibold mb-6" style={{ color: "var(--text)" }}>Mot de passe</h2>
            <div className="border rounded-xl p-5 space-y-4" style={{ borderColor: "var(--border)" }}>
              <div>
                <label className="block text-sm font-medium mb-1" style={{ color: "var(--text-muted)" }}>Ancien mot de passe</label>
                <input type="password" value={ancienPassword} onChange={(e) => setAncienPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style={{ backgroundColor: "var(--bg)", borderColor: "var(--border)", color: "var(--text)" }}/>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1" style={{ color: "var(--text-muted)" }}>Nouveau mot de passe</label>
                <input type="password" value={nouveauPassword} onChange={(e) => setNouveauPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style={{ backgroundColor: "var(--bg)", borderColor: "var(--border)", color: "var(--text)" }}/>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1" style={{ color: "var(--text-muted)" }}>Confirmer le nouveau mot de passe</label>
                <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style={{ backgroundColor: "var(--bg)", borderColor: "var(--border)", color: "var(--text)" }}/>
              </div>
              <button onClick={handlePasswordChange}
                className="w-full py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition">
                Changer de mot de passe
              </button>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen px-4 py-10" style={{ backgroundColor: "var(--bg)" }}>
      <div className="max-w-5xl mx-auto">

        <h1 className="text-2xl font-bold mb-8" style={{ color: "var(--text)" }}>Paramètres du compte</h1>

        {(feedback || error) && (
          <div className={`mb-4 p-3 rounded-lg text-sm ${error ? "bg-red-50 border border-red-200 text-red-600" : "bg-green-50 border border-green-200 text-green-700"}`}>
            {feedback || error}
          </div>
        )}

        <div className="flex gap-8">
         
          <aside className="w-56 shrink-0">
            {NAV_ITEMS.map(({ section, items }) => (
              <div key={section} className="mb-6">
                <p className="text-xs font-bold uppercase tracking-widest mb-2 px-2" style={{ color: "var(--text-muted)" }}>
                  {section}
                </p>
                {items.map((item) => (
                  <button key={item}
                    onClick={() => setActivePage(item)}
                    className={`w-full text-left px-3 py-2 rounded-lg text-sm transition mb-0.5 ${
                      activePage === item
                        ? "bg-blue-600 text-white font-medium"
                        : "hover:bg-gray-100 dark:hover:bg-slate-700"
                    }`}
                    style={activePage !== item ? { color: "var(--text)" } : {}}>
                    {item}
                  </button>
                ))}
              </div>
            ))}
          </aside>

         
          <main className="flex-1 border rounded-xl p-8"
            style={{ backgroundColor: "var(--bg-card)", borderColor: "var(--border)" }}>
            {renderPage()}
          </main>
        </div>
      </div>
    </div>
  );
}*/




import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../config";
import { useTheme } from "../context/ThemeContext";

const NAV_ITEMS = [
  { section: "Général", items: ["Infos d'abonnement", "Préférences", "Notifications"] },
  { section: "Compte", items: ["E-mail", "Mot de passe"] },
];

export default function Parametres() {
  const navigate = useNavigate();
  const { theme, setTheme } = useTheme();
  const token = localStorage.getItem("token");
  const [user, setUser] = useState(null);
  const [activePage, setActivePage] = useState("Préférences");
  const [feedback, setFeedback] = useState("");
  const [error, setError] = useState("");

  // États formulaires
  const [langue, setLangue] = useState("fr");
  const [langueNotif, setLangueNotif] = useState("fr");
  const [ancienPassword, setAncienPassword] = useState("");
  const [nouveauPassword, setNouveauPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    if (!token) return navigate("/login");
    fetch(`${API_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((data) => {
        setUser(data);
        setLangue(data.langue || "fr");
        setLangueNotif(data.langueNotification || "fr");
      });
  }, [token, navigate]);

  const notify = (msg, isError = false) => {
    if (isError) setError(msg);
    else setFeedback(msg);
    setTimeout(() => { setFeedback(""); setError(""); }, 3000);
  };

  const saveSettings = async (payload) => {
    const res = await fetch(`${API_URL}/api/auth/update-settings`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(payload),
    });
    return res.ok;
  };

  const handleThemeChange = async (newTheme) => {
    setTheme(newTheme);
    await saveSettings({ theme: newTheme });
  };

  const handleLangueChange = async (val) => {
    setLangue(val);
    await saveSettings({ langue: val });
    notify("✅ Langue sauvegardée");
  };

  const handleLangueNotifChange = async (val) => {
    setLangueNotif(val);
    await saveSettings({ langueNotification: val });
    notify("✅ Préférence notification sauvegardée");
  };

  const handlePasswordChange = async () => {
    if (nouveauPassword !== confirmPassword)
      return notify("Les mots de passe ne correspondent pas", true);
    const res = await fetch(`${API_URL}/api/auth/change-password`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ ancienPassword, nouveauPassword }),
    });
    const data = await res.json();
    if (!res.ok) return notify(data.message, true);
    notify("✅ Mot de passe modifié !");
    setAncienPassword(""); setNouveauPassword(""); setConfirmPassword("");
  };

  const handleEmailChange = async () => {
    const res = await fetch(`${API_URL}/api/auth/request-email-change`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
    });
    const data = await res.json();
    notify(data.message);
  };

  if (!user) return <div className="text-center mt-20" style={{ color: "var(--text-muted)" }}>Chargement...</div>;

  const renderPage = () => {
    switch (activePage) {
      case "Infos d'abonnement":
        return (
          <div>
            <h2 className="text-xl font-semibold mb-6" style={{ color: "var(--text)" }}>Informations d'abonnement</h2>
            <div className="border rounded-xl p-6 space-y-4" style={{ borderColor: "var(--border)" }}>
              <div className="flex justify-between">
                <span style={{ color: "var(--text-muted)" }}>Plan actuel</span>
                <span className="font-semibold text-blue-600">{user.abonnement || "Gratuit"}</span>
              </div>
              <div className="flex justify-between">
                <span style={{ color: "var(--text-muted)" }}>Prochain paiement</span>
                <span style={{ color: "var(--text)" }}>
                  {user.prochainPaiement
                    ? new Date(user.prochainPaiement).toLocaleDateString("fr-FR")
                    : "—"}
                </span>
              </div>
              <div className="flex justify-between">
                <span style={{ color: "var(--text-muted)" }}>Membre depuis</span>
                <span style={{ color: "var(--text)" }}>{new Date(user.createdAt).toLocaleDateString("fr-FR")}</span>
              </div>
            </div>
          </div>
        );

      case "Préférences":
        return (
          <div>
            <h2 className="text-xl font-semibold mb-2" style={{ color: "var(--text)" }}>Préférences</h2>
            <p className="text-sm mb-6" style={{ color: "var(--text-muted)" }}>Définissez vos préférences d'affichage et de langue</p>

            <div className="space-y-6">
              {/* Mode */}
              <div className="border rounded-xl p-5" style={{ borderColor: "var(--border)" }}>
                <label className="block text-sm font-semibold mb-3" style={{ color: "var(--text-muted)" }}>
                  MODE D'AFFICHAGE
                </label>
                <div className="flex gap-3">
                  {[
                    { value: "light", label: "☀️ Mode jour" },
                    { value: "dark", label: "🌙 Mode nuit" },
                  ].map((opt) => (
                    <button key={opt.value}
                      onClick={() => handleThemeChange(opt.value)}
                      className={`flex-1 py-3 rounded-lg border text-sm font-medium transition ${
                        theme === opt.value
                          ? "bg-blue-600 text-white border-blue-600"
                          : "hover:border-blue-400"
                      }`}
                      style={theme !== opt.value ? { borderColor: "var(--border)", color: "var(--text)" } : {}}>
                      {opt.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Langue */}
              <div className="border rounded-xl p-5" style={{ borderColor: "var(--border)" }}>
                <label className="block text-sm font-semibold mb-3" style={{ color: "var(--text-muted)" }}>
                  LANGUE D'AFFICHAGE
                </label>
                <select value={langue} onChange={(e) => handleLangueChange(e.target.value)}
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style={{ backgroundColor: "var(--bg)", borderColor: "var(--border)", color: "var(--text)" }}>
                  <option value="fr">🇫🇷 Français</option>
                  <option value="en">🇬🇧 English</option>
                </select>
              </div>
            </div>
          </div>
        );

      case "Notifications":
        return (
          <div>
            <h2 className="text-xl font-semibold mb-2" style={{ color: "var(--text)" }}>Notifications</h2>
            <p className="text-sm mb-6" style={{ color: "var(--text-muted)" }}>Choisissez la langue de vos emails de notification</p>

            <div className="border rounded-xl p-5" style={{ borderColor: "var(--border)" }}>
              <label className="block text-sm font-semibold mb-3" style={{ color: "var(--text-muted)" }}>
                LANGUE DES EMAILS
              </label>
              <select value={langueNotif} onChange={(e) => handleLangueNotifChange(e.target.value)}
                className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                style={{ backgroundColor: "var(--bg)", borderColor: "var(--border)", color: "var(--text)" }}>
                <option value="fr">🇫🇷 Français</option>
                <option value="en">🇬🇧 English</option>
              </select>
            </div>
          </div>
        );

      case "E-mail":
        return (
          <div>
            <h2 className="text-xl font-semibold mb-6" style={{ color: "var(--text)" }}>Adresse e-mail</h2>
            <div className="border rounded-xl p-5 space-y-4" style={{ borderColor: "var(--border)" }}>
              <div>
                <p className="text-sm mb-1" style={{ color: "var(--text-muted)" }}>Adresse actuelle</p>
                <p className="font-medium" style={{ color: "var(--text)" }}>{user.email}</p>
              </div>
              <button onClick={handleEmailChange}
                className="w-full py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition">
                Envoyer le lien de modification d'e-mail
              </button>
              <p className="text-xs text-center" style={{ color: "var(--text-muted)" }}>
                Vous rencontrez des difficultés ?{" "}
                <a href="/contact" className="text-blue-500 hover:underline">Contactez le support client.</a>
              </p>
            </div>
          </div>
        );

      case "Mot de passe":
        return (
          <div>
            <h2 className="text-xl font-semibold mb-6" style={{ color: "var(--text)" }}>Mot de passe</h2>
            <div className="border rounded-xl p-5 space-y-4" style={{ borderColor: "var(--border)" }}>
              <div>
                <label className="block text-sm font-medium mb-1" style={{ color: "var(--text-muted)" }}>Ancien mot de passe</label>
                <input type="password" value={ancienPassword} onChange={(e) => setAncienPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style={{ backgroundColor: "var(--bg)", borderColor: "var(--border)", color: "var(--text)" }}/>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1" style={{ color: "var(--text-muted)" }}>Nouveau mot de passe</label>
                <input type="password" value={nouveauPassword} onChange={(e) => setNouveauPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style={{ backgroundColor: "var(--bg)", borderColor: "var(--border)", color: "var(--text)" }}/>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1" style={{ color: "var(--text-muted)" }}>Confirmer le nouveau mot de passe</label>
                <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="••••••••"
                  className="w-full border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  style={{ backgroundColor: "var(--bg)", borderColor: "var(--border)", color: "var(--text)" }}/>
              </div>
              <button onClick={handlePasswordChange}
                className="w-full py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition">
                Changer de mot de passe
              </button>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen px-4 py-10" style={{ backgroundColor: "var(--bg)" }}>
      <div className="max-w-5xl mx-auto">

        <h1 className="text-2xl font-bold mb-8" style={{ color: "var(--text)" }}>Paramètres du compte</h1>

        {(feedback || error) && (
          <div className={`mb-4 p-3 rounded-lg text-sm ${error ? "bg-red-50 border border-red-200 text-red-600" : "bg-green-50 border border-green-200 text-green-700"}`}>
            {feedback || error}
          </div>
        )}

        <div className="flex flex-col md:flex-row gap-6 md:gap-8">
          {/* Sidebar — horizontale sur mobile, verticale sur desktop */}
          <aside className="w-full md:w-56 md:shrink-0">
            {NAV_ITEMS.map(({ section, items }) => (
              <div key={section} className="mb-4 md:mb-6">
                <p className="text-xs font-bold uppercase tracking-widest mb-2 px-2 hidden md:block" style={{ color: "var(--text-muted)" }}>
                  {section}
                </p>
                <div className="flex md:flex-col flex-row gap-1 overflow-x-auto pb-1 md:pb-0">
                {items.map((item) => (
                  <button key={item}
                    onClick={() => setActivePage(item)}
                    className={`whitespace-nowrap md:w-full text-left px-3 py-2 rounded-lg text-sm transition ${ 
                      activePage === item
                        ? "bg-blue-600 text-white font-medium"
                        : "hover:bg-gray-100 dark:hover:bg-slate-700"
                    }`}
                    style={activePage !== item ? { color: "var(--text)" } : {}}>
                    {item}
                  </button>
                ))}
                </div>
              </div>
            ))}
          </aside>

          {/* Content */}
          <main className="flex-1 border rounded-xl p-8"
            style={{ backgroundColor: "var(--bg-card)", borderColor: "var(--border)" }}>
            {renderPage()}
          </main>
        </div>
      </div>
    </div>
  );
}